import { Menu, MenuItem, TextField } from "@mui/material";
import React, { useEffect } from "react";

const ContextMenu = ({
  showContextMenu,
  isOpemContextMenu,
  handleCloseMenu,
  updateDataUsingManuallyContextMenu,
  parameterIndex,
  mappingIndex,
  contextEvent,
}) => {
  const initialPointers = {
    mouseX: null,
    mouseY: null,
  };

  const [pointers, setPointers] = React.useState(initialPointers);
  const [dragToValues, setDragToValues] = React.useState(null);

  useEffect(() => {
    if (contextEvent) {
      setPointers({
        mouseX: contextEvent.clientX - 2,
        mouseY: contextEvent.clientY - 4,
      });
    }
    setDragToValues(null);
  }, [contextEvent]);

  const handleCloseMenuParent = () => {
    setPointers(initialPointers);
    setDragToValues(null);
    handleCloseMenu();
  };

  const onEntered = () => {
    setPointers(initialPointers);
    dragToValues?.nos &&
      updateDataUsingManuallyContextMenu(
        parameterIndex,
        mappingIndex,
        dragToValues
      );
  };

  const dragInTo = (pos, value) => {
    setDragToValues({
      pos: pos,
      nos: value,
    });
  };

  return (
    <div>
      {" "}
      {showContextMenu && isOpemContextMenu && (
        <Menu
          className="context-menu"
          PaperProps={{
            style: {
              width: 220,
            },
          }}
          keepMounted
          open={pointers.mouseY !== null}
          onClose={handleCloseMenuParent}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              onEntered();
            }
          }}
          anchorReference="anchorPosition"
          anchorPosition={
            pointers.mouseY !== null && pointers.mouseX !== null
              ? { top: pointers.mouseY, left: pointers.mouseX }
              : undefined
          }
        >
          <MenuItem>
            <span className="copy-label">Copy to below</span>
            <TextField
              className="mx-5"
              type="number"
              inputProps={{
                style: {
                  fontSize: "15px",
                  width: "35px",
                  padding: "5px",
                },
                min: "0",
              }}
              value={
                dragToValues?.pos === "below" && dragToValues?.nos
                  ? dragToValues?.nos
                  : ""
              }
              disabled={dragToValues !== null && dragToValues?.pos !== "below"}
              onChange={(e) => dragInTo("below", e.target.value)}
            />
            cells
          </MenuItem>
          <MenuItem>
            <span className="copy-label">Copy to above</span>
            <TextField
              className="mx-5"
              type="number"
              inputProps={{
                style: {
                  fontSize: "15px",
                  width: "35px",
                  padding: "5px",
                },
                min: "0",
              }}
              value={
                dragToValues?.pos === "above" && dragToValues?.nos
                  ? dragToValues?.nos
                  : ""
              }
              disabled={dragToValues !== null && dragToValues?.pos !== "above"}
              onChange={(e) => dragInTo("above", e.target.value)}
            />
            cells
          </MenuItem>{" "}
          <MenuItem>
            <span className="copy-label">Copy to right</span>
            <TextField
              className="mx-5"
              type="number"
              inputProps={{
                style: {
                  fontSize: "15px",
                  width: "35px",
                  padding: "5px",
                },
                min: "0",
              }}
              value={
                dragToValues?.pos === "right" && dragToValues?.nos
                  ? dragToValues?.nos
                  : ""
              }
              disabled={dragToValues !== null && dragToValues?.pos !== "right"}
              onChange={(e) => dragInTo("right", e.target.value)}
            />
            cells
          </MenuItem>{" "}
          <MenuItem>
            <span className="copy-label">Copy to left</span>
            <TextField
              className="mx-5"
              type="number"
              inputProps={{
                style: {
                  fontSize: "15px",
                  width: "35px",
                  padding: "5px",
                },
                min: "0",
              }}
              value={
                dragToValues?.pos === "left" && dragToValues?.nos
                  ? dragToValues?.nos
                  : ""
              }
              disabled={dragToValues !== null && dragToValues?.pos !== "left"}
              onChange={(e) => dragInTo("left", e.target.value)}
            />
            cells
          </MenuItem>
        </Menu>
      )}
    </div>
  );
};

export default ContextMenu;
